import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);

// Client-side caches keyed off the user's role. Rewritten (2026-02-11) so
// that when a role changes (Accounts → Authorizer, say) we blow away any
// cached sanctioned-bearing responses that the previous role could see.
function _wipeRoleCaches() {
  try {
    Object.keys(sessionStorage)
      .filter(k => k.startsWith("rollup:") || k.startsWith("sanctioned:") || k.startsWith("budgetA:"))
      .forEach(k => sessionStorage.removeItem(k));
  } catch { /* noop */ }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const _applyUser = (u) => {
    if (u && user && u.role !== user.role) _wipeRoleCaches();
    setUser(u);
  };

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) { setLoading(false); return; }
    api.get("/auth/me")
      .then((r) => _applyUser(r.data))
      .catch(() => localStorage.removeItem("token"))
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const r = await api.post("/auth/login", { email, password });
    localStorage.setItem("token", r.data.token);
    _wipeRoleCaches();  // fresh login → drop any stale role-scoped cache
    setUser(r.data.user);
    return r.data;
  };

  const register = async (payload) => {
    const r = await api.post("/auth/register", payload);
    return r.data;
  };

  const logout = () => {
    localStorage.removeItem("token");
    _wipeRoleCaches();
    setUser(null);
  };

  return (
    <AuthCtx.Provider value={{ user, login, register, logout, loading }}>
      {children}
    </AuthCtx.Provider>
  );
}

export const useAuth = () => useContext(AuthCtx);
